import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

export const IconContainer = styled.span<{ $color?: string }>`
  font-size: 1.6rem;
  line-height: 62.5%;
  margin: ${({ theme }) => theme.spacing(1)};

  ${({ $color, theme }) =>
    $color &&
    css`
      color: ${schemeColor($color, theme)};
    `};
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChevronContainer = styled.span`
  transform: rotate(180deg);

  color: ${({ theme }) => theme.palette.grey[700]};
  line-height: 62.5%;
  font-size: 1.6rem;
`;
